import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
import { OPENING_HOURS, SERVICE_MENUS } from '../data/locations';
import { SectionHeading } from './SectionHeading';
type PricingMenusProps = {
  headingId?: string;
};
export function PricingMenus({
  headingId = 'pricing-heading'
}: PricingMenusProps) {
  return <div className="rounded-2xl border border-lotus-500/20 bg-ink-900/70 p-8 sm:p-14" data-id="element-100" data-mp="2fyxt5kpetyfj">
      <SectionHeading id={headingId} eyebrow="The Menu" title="Our Services" accent="Services" subtitle="Therapists trained across East and Southeast Asia, at every location." data-id="element-101" data-mp="2tyfneflh63wa" />

      <div className="mt-14 grid gap-6 lg:grid-cols-2" data-id="element-102" data-mp="33rmovpd3gzr3">
        {SERVICE_MENUS.map((menu, i) => <motion.section key={menu.name} initial={{
        opacity: 0,
        y: 18
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.45,
        delay: i * 0.08,
        ease: 'easeOut'
      }} aria-label={menu.name} className={`rounded-xl border p-8 transition-colors ${i === 0 ? 'border-lotus-500/25 bg-lotus-500/[0.06] hover:border-lotus-500/50' : 'border-orchid-500/25 bg-orchid-500/[0.06] hover:border-orchid-500/50'}`} data-id="element-103" data-mp="2yt31dkiurfwm" data-mpi={i}>
            <h3 className="font-display text-3xl font-light tracking-wide text-white" data-id="element-104" data-mp="2ksm7rk68pjy4">
              {menu.name}
            </h3>
            <p className="mt-3 text-sm font-light leading-relaxed text-neutral-300" data-id="element-105" data-mp="2pqxhzw0g5wgv">
              {menu.description}
            </p>
            <ul className="mt-7 divide-y divide-white/10" data-id="element-106" data-mp="2uixne3zadhku">
              {menu.tiers.map(tier => <li key={tier.duration} className="flex items-baseline justify-between gap-4 py-4" data-id="element-107" data-mp="2zgqt6vwog9kl">
                  <span className="text-sm font-light uppercase tracking-[0.16em] text-neutral-200" data-id="element-108" data-mp="34ig6ki7dgzbu">
                    {tier.duration}
                  </span>
                  <span className={`font-display text-3xl font-light ${i === 0 ? 'text-lotus-400' : 'text-orchid-300'}`} data-id="element-109" data-mp="19cnl3pvjtd6i">
                    {tier.price}
                  </span>
                </li>)}
            </ul>
          </motion.section>)}
      </div>

      <aside className="mx-auto mt-8 flex max-w-2xl items-start gap-4 rounded-xl border border-orchid-400/40 bg-orchid-500/[0.12] p-6 text-left" data-id="element-110" data-mp="1s3y6xsmf2zrj">
        <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-orchid-500/25 text-orchid-200" data-id="element-111" data-mp="1n3sdq80i157c">
          <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-112" data-mp="212ik6e97kh8d" />
        </span>
        <p className="text-sm font-light leading-relaxed text-neutral-200" data-id="element-113" data-mp="1x3j6a45i1a4s">
          <span className="font-medium text-orchid-200" data-id="element-114" data-mp="6ptuf2psazjc">Additional services available.</span> Extras
          can be arranged on request and discussed discreetly with your therapist at the venue.
          Strictly ages 18+.
        </p>
      </aside>

      <p className="mt-8 text-center text-sm font-light tracking-wide text-neutral-400" data-id="element-115" data-mp="3osk691qb006t">
        All locations open <span className="text-lotus-400" data-id="element-116" data-mp="3stvt4zhsm7bb">{OPENING_HOURS}</span>
      </p>
    </div>;
}